<template>
  <div class="container">
    <section class="jumbotron text-center">
      <div class="container">
        <h1 class="jumbotron-heading">Top {{topMap[myFavListEver.length]}}</h1>
        <!-- <p class="lead text-muted">
          my favorite list so far
          <span style="font-size:25px">&#128526;</span>
        </p> -->
        <!-- <p>
          <em class="lead">
            language:
            <router-link style="text-decoration: none; color: inherit;" to="/">EN</router-link> /
            <router-link style="text-decoration: none; color: inherit;" to="/film-zh">中文</router-link>
          </em>
        </p> -->
      </div>
    </section>
     <ul>
      <li class="title-list" v-for="film in myFavListEver" :key="film.title">
        {{ film.title }} ({{ film.year }})
        <span style="font-size:25px">{{ film.emoji }}</span>
      </li>
    </ul>
    <section class="jumbotron text-center">
      <div class="container">
        <h1 class="jumbotron-heading">Likes in {{ currYear }}</h1>
        <span>
          <em class="lead">updated {{ updDate.month }}/{{ updDate.day }}/{{ updDate.year }}</em>
        </span>
      </div>
    </section>
    <ul>
      <li class="title-list" v-for="film in myFavListCurrYear" :key="film.title">
        {{ film.title }} ({{ film.year }})
        <span style="font-size:25px">{{ film.emoji }}</span>
      </li>
    </ul>
    <section class="jumbotron text-center">
      <div class="container">
        <router-link class="btn2 btn-light scale-medium" style="text-decoration: none; color: inherit;" to="/recommend-a-film">
          Recommend a film?
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import store from '@/store.js';
console.log(`# of myFavListEver: ${store.films.myFavListEver.length}`);
console.log(`# of myFavListCurrYear: ${store.films.myFavListCurrYear.length}`);

export default {
  name: 'Houqis-Film-Collection',
  components: {},
  data() {
    return {
      myFavListEver: store.films.myFavListEver,
      myFavListCurrYear: store.films.myFavListCurrYear,
      updDate: store.films.updDate,
      currYear: store.films.currYear,
      topMap: {
        1: 'One',
        2: 'Two',
        3: 'Three',
        4: 'Four',
        5: 'Five',
        6: 'Six',
        7: 'Seven',
        8: "Eight",
        9: 'Nine',
        10: 'Ten'
      }
    };
  } 
};
</script>

<style>
.title-list {
  font-size: 1.5em;
  padding: 0 0 20px 0;
  margin-bottom: 1rem;
}
</style>